import { getHttp } from '@/api/httpFactory';
import { API_URLS } from './urls';

const http = getHttp(import.meta.env.VITE_API_BASE_URL);

const qualificationApi = {
    /**
     * Create a new profile role for developer
     */
    async setDeveloper() {
        const resp = await http.post(API_URLS.QUALIFICATION.DEVELOPER);

        return resp;
    },
};

export default qualificationApi;
